import React from 'react'
import { ATLTextBody } from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../../atlTheme'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { messages } from '../../../constants/strings/messages'
import styled from 'styled-components/native'

const EmptyCardContainer = styled.View`
  background-color: ${atlTheme.ColorSurface};
  border-radius: ${atlTheme.BorderRadiusCard}px;
  margin-vertical: ${atlTheme.SpacingAtomic}px;
`

export interface EmptyCardProps {
  type: string
}

export const EmptyCard: React.FunctionComponent<EmptyCardProps> = ({ type }) => {
  return (
    <EmptyCardContainer>
      <ATLTextBody
        labelBaseProps={{
          multilineLimit: 1,
          fontSize: atlTheme.FontSizeHeading,
          lineHeight: atlTheme.LineHeightHeading,
          fontWeight: atlTheme.FontWeight500,
        }}
      >
        {`${formatMessage(messages.financeScreen_installments)} ${type}`}
      </ATLTextBody>
      <ATLTextBody labelBaseProps={{ multilineLimit: 1, textColor: atlTheme.ColorMediumContrast }}>
        {`${formatMessage(messages.financeScreen_emptyState_message)} ${type}`}
      </ATLTextBody>
    </EmptyCardContainer>
  )
}
